import { SettingsConsolePage } from "../../operator/console/settings-console";

export default function ConsoleSettingsRoute() {
  return <SettingsConsolePage />;
}
